export class RqChooseDocument {
    chosenDocumentId: string;

    constructor(chosenDocumentId: string) {
        this.chosenDocumentId = chosenDocumentId;
    }
}